import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background: white;
  position: relative;
  padding: 10px;
`;

export const List = styled.div`
  margin: 0 auto;
  width: calc(100% - 10px);
  & > div {
    margin-bottom: 10px;
  }
  @media (min-width: 426px) {
    width: 70%;
  }
`;
